export default function FooterCTA() {
  return (
    <div className="bg-gradient-to-r from-slate-800 to-slate-900 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <i className="ri-plane-fill text-6xl text-yellow-400"></i>
        </div>
        
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
          Bắt đầu lên kế hoạch cho chuyến đi Mỹ của bạn
        </h2>
        
        <p className="text-lg text-white/80 mb-8 max-w-2xl mx-auto">
          Để chúng tôi giúp bạn tạo ra một hành trình khó quên với những trải nghiệm tuyệt vời nhất
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-yellow-400 text-slate-900 px-8 py-3 rounded-lg text-sm font-semibold hover:bg-yellow-300 transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer">
            Xem tour du lịch Mỹ
          </button>
          <button className="border-2 border-white text-white px-8 py-3 rounded-lg text-sm font-semibold hover:bg-white hover:text-slate-900 transition-all duration-200 whitespace-nowrap cursor-pointer">
            Liên hệ tư vấn
          </button>
        </div>
      </div>
    </div>
  );
}